<template>
     <div>
           <fg-input
            type="tel"
            label="Логин"
            v-model="phone"
            placeholder="Введите телефон"
          ></fg-input>
          <fg-input
            type="password"
            label="Пароль"
            v-model="password"
            placeholder="Введите пароль"
          ></fg-input>
          <br />
          <p-button
            class="w-100 mb-3"
            type="warning"
            round
            @click.native.prevent="login"
            >Войти в систему</p-button
          >
          </div>
</template>

<script>
import { errorNotify } from "@/plugins/functions";

export default {
  name: "login",
  components: {},
  mounted() {},
  data() {
    return {
      phone: "",
      password: "",
    };
  },
  methods: {
    login(loading = true) {
      this.$loading(true);
      this.$http
        .post("auth/login", {
          phone: this.phone,
          password: this.password,
        })
        .then((response) => {
          let token = response.headers['x-access-token'];
          this.$http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          localStorage.setItem("token", `Bearer ${token}`);
          this.$store.dispatch("setUser", response.data);
          this.$store.dispatch("setRoutes", response.data.routes);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    },
  },
};
</script>
<style>
</style>
